import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const API_URL = process.env.REACT_APP_BASE_URL;

const ThemeUpload = () => {
  const [themeFile, setThemeFile] = useState(null);
  const [parentOptions, setParentOptions] = useState([]);
  const [selectedParentNos, setSelectedParentNos] = useState([]);
  const [showParentDropdown, setShowParentDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadComplete, setUploadComplete] = useState(false);


  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dropdown")) {
        setShowParentDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Load parent options
  useEffect(() => {
    fetch(`${API_URL}GetShopifyStores.php`)
      .then(res => res.json())
      .then(data => {
        setParentOptions(data);
      })
      .catch(err => {
        toast.error("Failed to load parent numbers");
        console.error(err);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!themeFile || selectedParentNos.length === 0) {
      toast.error("Please select at least one Parent No and upload a theme file.");
      return;
    }

    try {
      setUploadComplete(false);

      setLoading(true);
      const storeResponse = await fetch(`${API_URL}GetStoreDetailsByParent.php`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ parentnos: selectedParentNos })
      });

       const storeData = await storeResponse.json();
             if (!Array.isArray(storeData) || storeData.length === 0) {
               toast.error("No store data found.");
               setLoading(false);
               return;
             }

      const formData = new FormData();
      formData.append("theme_zip", themeFile);
      formData.append("store_data", JSON.stringify(storeData));

      const uploadRes = await fetch(`${API_URL}ShopifyThemeUpload.php`, {
        method: "POST",
        body: formData
      });

      const result = await uploadRes.json();
      setLoading(false);

      if (result.success) {
        toast.success("Theme uploaded successfully!");
        setUploadComplete(true);
        setSelectedParentNos([]);
        document.getElementById("themezipfileinput").value = "";
      } else {
        toast.error(result.message || "Upload failed.");
      }
    } catch (err) {
      toast.error("Error uploading theme.");
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <div className="container-fluid page-body-wrapper">
      <ToastContainer
                            position="top-center"
                            autoClose={500}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="colored"
                          />
      <div className="main-panel">
        <div className="content-wrapper" style={{ paddingBottom: "80px" }}>
          <div className="container mainbody1" style={{ maxWidth: '1900px' }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h2 className="form-header">Theme Upload to Shopify</h2>
              <Link to="/shopifydataimport" className="btn btn-success btn-sm">
                <i className="mdi mdi-arrow-right"></i> Data Import
              </Link>
            </div>

            <form onSubmit={handleSubmit} encType="multipart/form-data">
              {/* Custom Multi-Select Dropdown with Checkboxes */}
              <div className="form-group" style={{ display: "flex", flexDirection: "column", position: "relative" }}>
                <label style={{ marginBottom: "8px" }}>
                  Parent No: <span className="requireds">*</span>
                </label>

                <div className="dropdown" style={{ width: "100%", position: "relative" }}>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => setShowParentDropdown(!showParentDropdown)}
                    style={{
                      width: "100%",
                      color: "#000000",
                      textAlign: "left",
                      padding: "10px 40px 10px 12px",
                      border: "1px solid #ced4da",
                      position: "relative",
                    }}
                  >
                    {selectedParentNos.length > 0 ? selectedParentNos.join(", ") : "Select Parent No"}
                    <span
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    >
                      ▼
                    </span>
                  </button>

                  {showParentDropdown && (
                    <div
                      className="dropdown-menu show"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: "0",
                        width: "100%",
                        maxHeight: "200px",
                        overflowY: "auto",
                        padding: "10px",
                        zIndex: 999,
                        border: "1px solid #ced4da",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        columnGap: "20px",
                        rowGap: "10px",
                        background: "#fff",
                      }}
                    >
                      {/* Select All */}
                      <div style={{ gridColumn: "1 / -1", marginBottom: "5px" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
                          <input
                            type="checkbox"
                            checked={selectedParentNos.length === parentOptions.length}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedParentNos(parentOptions.map((p) => p.parentno));
                              } else {
                                setSelectedParentNos([]);
                              }
                            }}
                            style={{ width: "16px", height: "16px" }}
                          />
                          <strong>Select All</strong>
                        </label>
                      </div>

                      {/* Individual checkboxes */}
                      {parentOptions.map((opt) => (
                        <label
                          key={opt.parentno}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            margin: "0",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            value={opt.parentno}
                            checked={selectedParentNos.includes(opt.parentno)}
                            onChange={(e) =>
                              setSelectedParentNos((prev) =>
                                e.target.checked
                                  ? [...prev, opt.parentno]
                                  : prev.filter((val) => val !== opt.parentno)
                              )
                            }
                            style={{ width: "16px", height: "16px" }}
                          />
                          <span>{opt.parentno}</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label>Upload Theme ZIP File<span className="requireds">*</span></label>
                <input
                id = "themezipfileinput"
                  type="file"
                  className="form-control"
                  accept=".zip"
                  onChange={(e) => setThemeFile(e.target.files[0])}
                  required
                />
              </div>

               <center>
                  {!uploadComplete && (
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? "Uploading..." : "Upload"}
                    </button>
                  )}

                  <br /><br />

                  {uploadComplete && (
                    <Link to="/shopifydataimport" className="btn btn-success btn-sm">
                      <i className="mdi mdi-arrow-right"></i>Import Data to Shopify
                    </Link>
                  )}
                </center>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeUpload;
